import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import SoftwareReportContext from './SoftwareReportContext'
import SummaryTable from './SummaryTable'

const CloudCoreSummary = ({ data, Filters, children }) => (
  <SoftwareReportContext.Consumer>
    {({ filters, filterOptions, changeFilters, showNonSummarisedData }) => {
      if (!filters.showSummary) { return children }

      return (
        <Fragment>
          <div className="row mb-3 mt-3">
            <div className='col d-flex align-items-end'>
              <button type='button' className='btn btn-outline-primary' onClick={() => showNonSummarisedData('all')}>
                Show all
              </button>
            </div>
          </div>

          <Filters {...{ filters, filterOptions, changeFilters }} />

          <SummaryTable {...{ filters, data, showNonSummarisedData }} />
        </Fragment>
      )
    }}
  </SoftwareReportContext.Consumer>
)

export default CloudCoreSummary
